const API_ENDPOINT = '/api/2025-04/graphql.json';
const STOREFRONT_ACCESS_TOKEN = '3cc06f0509e0accf19b4381b856d6d72';

// Storefront API 호출 
async function fetchStorefrontApi(query, variables) {
  const response = await fetch(API_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN
    },
    body: JSON.stringify({ query, variables })
  });
  const result = await response.json();
  return result.data || {};
}

// 소셜 로그인 API 호출
async function socialLoginApi(type, value) {
  if (!type || !value) {
    throw new Error('로그인 정보가 유효하지 않습니다.');
  }

  const url = `https://pulsar.lukuku.co/api/social/${type}/login`;
  const body = {
    [type === 'kakao' ? 'code' : 'accessToken']: value,
  };
  
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  
  const data = await response.json();
  return data;
}

// customerAccessToken 생성
async function loginAndGetCustomerAccessToken(email, password) {
  const query = `
    mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
      customerAccessTokenCreate(input: $input) {
        customerAccessToken {
          accessToken
          expiresAt
        }
        customerUserErrors {
          code
          field
          message
        }
      }
    }
  `;
  const variables = { input: { email, password } };
  const data = await fetchStorefrontApi(query, variables);

  const customerAccessToken = data?.customerAccessTokenCreate?.customerAccessToken?.accessToken;
  return customerAccessToken;
}

// customerAccessToken 생성 (multipass)
async function loginAndGetCustomerAccessTokenWithMultipass(multipassToken) {
  const query = `
    mutation customerAccessTokenCreateWithMultipass($multipassToken: String!) {
      customerAccessTokenCreateWithMultipass(multipassToken: $multipassToken) {
        customerAccessToken {
          accessToken
          expiresAt
        }
        customerUserErrors {
          code
          field
          message
        }
      }
    }
  `;
  const variables = { multipassToken };
  const data = await fetchStorefrontApi(query, variables);

  const customerAccessToken = data?.customerAccessTokenCreateWithMultipass?.customerAccessToken?.accessToken;
  return customerAccessToken;
}

window.ApiUtils = {
  fetchStorefrontApi,
  socialLoginApi,
  loginAndGetCustomerAccessToken,
  loginAndGetCustomerAccessTokenWithMultipass
}; 